















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { GuestList, GuestState } from '@/services/Guests'
import { Room } from '@/services/Rooms'

@Component
export default class ListOfRooms extends Vue {
  @Prop({ required: true }) public value!: string
  @Prop({ required: true }) public guests!: GuestList
  @Prop({ required: true }) public roomsList!: Room[]
  @Prop({ required: true }) public guestsWithoutRoom!: GuestList

  public activeRoomId: string | null = this.value

  public mounted() {
    this.showRoom(null)
  }

  public async showRoom(roomId: string | null) {
    this.activeRoomId = roomId
    this.$emit('input', roomId)
  }

  public get areThereNewGuestsInTheLobby() {
    return Object.keys(this.guestsWithoutRoom).find(
      (guestId: string) => this.guestsWithoutRoom[guestId].state === GuestState.Welcome
    )
  }

  public get nrOfLobbyGuests() {
    return this.getActiveGuests(this.guestsWithoutRoom)
  }

  public getAttentionByRoomId(roomId: string | null) {
    return (
      Object.keys(this.guests).filter(
        key =>
          (roomId ? this.guests[key]?.room === roomId : !this.guests[key].room) &&
          this.guests[key]?.calledWaiter
      ).length > 0
    )
  }

  public getReturningByRoomId(roomId: string | null) {
    return (
      Object.keys(this.guests).filter(
        key =>
          (roomId ? this.guests[key]?.room === roomId : !this.guests[key].room) &&
          this.guests[key]?.state === GuestState.Returning
      ).length > 0
    )
  }

  public getTimersFinishedByRoomId(roomId: string | null) {
    return (
      Object.keys(this.guests).filter(
        key =>
          (roomId ? this.guests[key]?.room === roomId : !this.guests[key].room) &&
          this.guests[key]?.timerFinished
      ).length > 0
    )
  }

  public getActiveGuests(guests: GuestList) {
    if (!guests) {
      return 0
    }
    return Object.keys(guests).length
  }

  public getActiveGuestsByRoomId(roomId: string | null) {
    return Object.keys(this.guests).filter(key => this.guests[key]?.room === roomId)
  }

  @Watch('value')
  handleValueChange() {
    this.activeRoomId = this.value
  }
}
